<template>
  <div class="case-review-poster-popup">
    <van-popup
      v-model="innerVisible"
      :close-on-click-overlay="false"
      round
    >
      <div class="popup-body">
        <img :src="posterUrl" class="poster-img" alt="" />
        <div class="confirm-btn" @click="handleConfirm">点击进入病例评鉴列表</div>
      </div>
      <div class="close-btn" @click="handleClose">
        <img src="@/assets/images/home/ic_fork@2x.png" class="close-btn-img" alt="" />
      </div>
    </van-popup>
  </div>
</template>

<script>

export default {
  name: 'CaseReviewPosterPopup',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    posterUrl: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      innerVisible: this.value
    }
  },
  watch: {
    value (val) {
      this.innerVisible = val
    },
    innerVisible (val) {
      this.$emit('input', val)
    },
  },
  methods: {
    handleClose () {
      this.$emit('close')
    },
    handleConfirm () {
      this.$emit('confirm')
    }
  }
}
</script>

<style lang="less" scoped>
.case-review-poster-popup {
  /deep/ .van-popup {
    background-color: transparent;
    overflow-y: visible;
    z-index: 10006 !important;
  }

  .popup-body {
    width: 286px;
    min-height: 60px;
    position: relative;
    border-radius: 10px;
    overflow: hidden;
    background: #fff;
  }

  .close-btn {
    position: absolute;
    top: -36px;
    right: 0;
    width: 28px;
    height: 28px;
    z-index: 2;

    .close-btn-img {
      width: 28px;
      height: 28px;
      display: block;
    }
  }

  .poster-img {
    display: block;
    width: 100%;
    height: auto;
    object-fit: cover;
  }

  .confirm-btn {
    position: absolute;
    left: 50%;
    bottom: 6px;
    transform: translateX(-50%);
    width: calc(100% - 120px);
    height: 32px;
    background: #EB1700;
    border-radius: 16px;
    font-size: 12px;
    font-weight: 600;
    color: #fff;
    line-height: 32px;
    text-align: center;
    z-index: 2;
  }
}

/deep/ .van-overlay {
  z-index: 10005 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/CaseReviewPosterPopup.vue